import React, { useEffect, useRef, useState } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import Next from './next'

export default function CapsuleSetupImporting({ finished, next = () => {} }) {
    return (
        <div>
            <Next />
            {finished && (
                <Button
                    className='button-primary button-fullwidth mar-t32'
                    onClick={next}
                    iconRight={<Icons icon='arrowRight' />}
                >
                    Let's select your marketing contacts
                </Button>
            )}
        </div>
    )
}
